<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Penyaluran Donasi</div>
        </div>
        <!-- * App Header -->

        <!-- App Capsule -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section inset mt-2"
                v-if="penyaluran_donasi.data.length > 0"
            >
                <div
                    class="wide-block pt-0 pl-0 pr-0 mb-2"
                    style="cursor: pointer;"
                    v-for="(item, index) in penyaluran_donasi.data"
                    :key="index"
                    @click="redirectToArticel(item.link)"
                >
                    <div class="img-sedekah">
                        <img
                            :src="
                                VUE_ENV.VUE_APP_ASSET_URL +
                                    '/img/donasi/' +
                                    item.image
                            "
                            class="w-100 full"
                        />
                    </div>
                    <div class="p-1">
                        <h4>
                            <strong class="strong-bold">{{
                                item.title
                            }}</strong>
                        </h4>
                        <div
                            style="font-size:13px;line-height:18px;margin-bottom: 10px;"
                            v-html="item.content"
                        ></div>
                        <footer>
                            <div class="row">
                                <div class="col-6 text-left">
                                    <small class="title">Tanggal</small>
                                    <h5 class="total text-primary">
                                        <span>{{ item.date | date }}</span>
                                    </h5>
                                </div>
                                <div class="col-6 text-right">
                                    <small class="title">Tersalurkan</small>
                                    <h5 class="total text-primary">
                                        <span
                                            >Rp
                                            {{ item.nominal | rupiah }}</span
                                        >
                                    </h5>
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
                <div
                    class="m-2 text-center"
                    v-if="penyaluran_donasi.next_page_url"
                >
                    <ButtonLoader
                        :loading="loading.button"
                        :styled="'btn btn-primary rounded mr-1 mb-1'"
                        @click.native="
                            paginate(penyaluran_donasi.next_page_url)
                        "
                        >Lihat lebih banyak</ButtonLoader
                    >
                </div>
            </div>
            <div class="section mt-2" v-else>
                <div class="text-center" style="margin-top:100px;">
                    <img
                        :src="require('@/assets/image/404.svg')"
                        alt="404"
                        class="w-75 mb-3"
                    /><br />
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
        <!-- * App Capsule -->
    </div>
</template>
<script>
    import $axios from '../../api.js';
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: true,
                penyaluran_donasi: {},
            };
        },
        created() {
            //
        },
        computed: {
            ...mapState(['loading', 'VUE_ENV']),
        },
        methods: {
            paginate(url = '') {
                this.$store.commit('SET_LOADING', { button: true });
                $axios
                    .get(url ? url : '/donasi/penyaluran')
                    .then(response => {
                        if (!this.penyaluran_donasi.data) {
                            this.penyaluran_donasi = response.data;
                        } else {
                            this.penyaluran_donasi.data.push(
                                ...response.data.data
                            );
                            this.penyaluran_donasi.next_page_url =
                                response.data.next_page_url;
                        }
                        this.$store.commit('SET_LOADING', { button: false });
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.$store.commit('SET_LOADING', { button: false });
                        this.loadingApp = false;
                    });
            },
            redirectToArticel(url) {
                if (url != null) {
                    window.open(url, '_blank');
                }
            },
        },
        mounted() {
            this.paginate();
        },

        destroyed() {
            this.$store.commit('RESET_LOADING');
        },
    };
</script>
<style>
    .img-sedekah {
        position: relative;
        width: 100%;
        /* height: 130px; */
        overflow: hidden;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
</style>
